import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { destroy, put } from '../modules/product'

import component from 'components/Products/Edit'

const mapActionCreators = {
  onSubmit: put,
  handleDelete: destroy // NOTE: this cannot be named destroy as reduxForm uses that..
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(mapActionCreators, dispatch),
  dispatch
})

const mapStateToProps = (state) => {
  const obj = {
    product: state.product,

    categories: state.categories,
    customers: state.customers,
    options: state.options,
    types: state.types,
    uoms: state.uoms,

    initialValues: Object.assign({}, { customers: [], prices: [] }, state.product)
  }

  obj.initialValues.customers = obj.initialValues.customers.filter(o => o && o.id)
  obj.initialValues.customers.push({ id: undefined })

  obj.initialValues.prices = obj.initialValues.prices.filter(o => o && o.price)
  obj.initialValues.prices.push({ price: undefined, uom_id: undefined, option_id: undefined })
  return obj
}

const form = reduxForm({
  form: 'edit-product',
  fields: [
    'id', 'name', 'type_id', 'category_id', 'customers[].id',
    'scientific_name', 'details', 'tasting_notes',
    'sourcing_location', 'sourcing_method', 'fishing_vessel',
    'default_uom_id', 'default_option_id', 'default_available',
    'increment_by', 'increment_iterations',
    'prices[].price', 'prices[].uom_id', 'prices[].option_id'
  ],
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'
    if (!state.type_id) errors.type_id = 'Please select a product type.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Products/containers/EditProductContainer.js